import FamilyService from '@/services/FamilyService';

const initialState = {
	inSearch: null,
	families: [],
	family: {},
	familySimple: {},
	newFamily: null,
	familyRedirect: null
};

export default {
	namespaced: true,

	//#region [ State ]
	state: {
		...initialState
	},
	//#endregion

	//#region [ Mutations ]
	mutations: {
		setFamilies(state, payload) {
			state.families = payload;
		},

		setFamily(state, payload) {
			state.family = payload;
		},

		setFamilySimple(state, payload) {
			state.familySimple = payload;
		},

		setNewFamily(state, payload) {
			state.newFamily = payload;
		},

		setFamilyRedirect(state, payload) {
			state.familyRedirect = payload;
		},

		setSearch(state, payload) {
			state.inSearch = payload;
		},

		reset(state) {
			let newState = { ...initialState, inSearch: state.inSearch };
			Object.assign(state, newState);
		}
	},
	//#endregion

	//#region [ Actions ]
	actions: {
		async getFamilies({ commit }) {
			try {
				const data = await FamilyService.getAllFamilies();
				commit('setFamilies', data);
			} catch (error) {
				console.log(error);
			}
		},
		async getFamilyById({ commit }, id) {
			try {
				let data = await FamilyService.getFamily(id);
				commit('setFamily', data.family);
				return data;
			} catch (error) {
				console.log(error);
			}
		},
		async getFamilySimpleById({ commit }, id) {
			try {
				let data = await FamilyService.getFamilySimple(id);
				commit('setFamilySimple', data);
				return data;
			} catch (error) {
				console.log(error);
			}
		},
		async setNewFamilyData({ commit }, newFamily) {
			commit('setNewFamily', newFamily);
		},

		setFamilyRedirect({ commit }, value) {
			commit('setFamilyRedirect', value);
		},

		setSearch({ commit }, value) {
			commit('setSearch', value);
		},

		resetState({ commit }) {
			commit('reset');
		},

		// eslint-disable-next-line no-unused-vars
		async saveFamily({ commit }, familyObj) {
			let { lastName, userId, children } = familyObj;
			try {
				let data = await FamilyService.postFamily(lastName, userId._id, children);
				return data;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async updateFamily({ commit }, familyObj) {
			let { _id, lastName, userId, children } = familyObj;
			try {
				let data = await FamilyService.putFamily(_id, lastName, userId._id, children);
				return data;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async updateDataFamily({ commit }, dataFamilyObj) {
			let { _id, params } = dataFamilyObj;
			try {
				await FamilyService.putDataFamily(_id, params);
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async updateDocumentFamily({ commit }, documentFamilyObj) {
			let { _id, params } = documentFamilyObj;
			try {
				await FamilyService.putDocumentFamily(_id, params);
			} catch (error) {
				console.log(error);
			}
		}
	},
	//#endregion

	//#region [ Getters ]
	getters: {}
	//#endregion
};
